import React, { useState } from 'react'
import styled from 'styled-components'
import { Select } from 'grommet'
import { FormInputContainer, FormInputLabel } from '@appearance/styled'
import i18n from '@localization/i18n'

export default ({
    value,
    label,
    placeholder = 'בחר/י',
    onSelect,
    required,
    onError,
    width,
    options,
    onDoneEdit,
}) => {
    const [isError, setIsError] = useState(false)
    const valueLabel = value ? value : null

    const isValid = () => !required || value !== placeholder

    const doSelect = (value) => {
        const valid = isValid() ? true : false
        console.log('isValid = ', valid)

        if (onSelect) {
            onSelect(value.value)
        }
        if (onError) {
            onError(!valid)
        }
        if (onDoneEdit) {
            onDoneEdit(valid)
        }
        setIsError(!valid)
    }

    return (
        <FormInputContainer width={width}>
            {label && (
                <FormInputLabel lang={i18n.locale}>
                    {label}
                    {required && <RequiredSign> * </RequiredSign>}
                </FormInputLabel>
            )}
            {valueLabel ? (
                <SelectWrapper>
                    <StyledSelectInput
                        valueLabel={valueLabel}
                        options={options || []}
                        placeholder={placeholder}
                        onChange={doSelect}
                        isError={isError}
                        onFocus={() => setIsError(false)}
                    />
                </SelectWrapper>
            ) : (
                <SelectWrapper2>
                    <StyledSelectInput2
                        valueLabel={valueLabel}
                        options={options || []}
                        placeholder={placeholder}
                        onChange={doSelect}
                        isError={isError}
                        onFocus={() => setIsError(false)}
                    />
                </SelectWrapper2>
            )}
        </FormInputContainer>
    )
}

const StyledSelectInput = styled(Select)`
    font-size: 13px;
    font-weight: 400;
    height: 55px;
    border-color: ${(p) => (p.isError ? 'red' : '#ccc')};
`
const SelectWrapper = styled.div`
    background: #fff;
    height: 42px;
    width: 100%;
    & > button {
        width: 100%;
        padding: 8px;
    }
`
const RequiredSign = styled.span`
    color: red;
`
const StyledSelectInput2 = styled(Select)`
    font-size: 13px;
    font-weight: 400;
    border-color: ${(p) => (p.isError ? 'red' : '#ccc')};
    align-items: center;
    margin-bottom: -4px;
`
const SelectWrapper2 = styled.div`
    background: #fff;
    height: 38px;
    width: 100%;
    & > button {
        width: 100%;
        margin: 0px 0px -8px 8px;
    }
`
